import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { mapProps, compose } from 'recompose'
import { Flex } from 'reflexbox'
import Switch from 'react-toolbox/lib/switch'

import withAllRoles from 'containers/Role/Hide/AllGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

import styles from './styles.scss'

const InfoSwitch = notifyHoc(Switch)

class Restricted extends Component {
  render() {
    return (
      <Flex styleName="restrictedContainerDiv">
        <span styleName='restrictedSpan'>Restricted</span>
        <InfoSwitch
          message={T.translate('pages.project.update.notification.restricted')}
          onChange={this.props.onChange}
          checked={this.props.restricted[0].value === 'Yes'}
        />
      </Flex>
    )
  }
}

const withStyle = CSSModules(styles)
export default compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  withAllRoles,
  withStyle
)(Restricted)
